<template>
  <div class="uploader-footer-wrapper">
    <ul>
      <li><a :href='websiteUrl'>{{ $t('public.footer.website')}}</a> <span>
        |
        </span>
      </li>
      <li><a :href='helpCenterUrl'>{{ $t('public.footer.help_center')}}</a>
      </li>
    </ul>
    <p>
      {{ $t('public.footer.address')}}
    </p>
    <p>
      {{ $t('public.footer.legal')}}
    </p>
    ©
    2020
    ecratum GmbH
  </div>
</template>

<script>
  export default {
    computed: {
      helpCenterUrl() {
        return this.locale == 'de' ? 'https://support.relatico.com/de/' : 'https://support.relatico.com/en/'
      },
      websiteUrl() {
        return `https://www.relatico.com/?lang=${this.locale}`
      },
      registrationUrl() {
        return `https://app.relatico.com/register?lang=${this.locale}`
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../styles/upload_page"
</style>
